// src/App.js
import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Consulting from "./pages/Consulting";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Setup from "./pages/Setup";
import WhatWeDo from "./pages/WhatWeDo";
import HowToRunSweepstakes from "./pages/HowToRunSweepstakes";
import Resources from "./pages/Resources";
import DropshippingSweepstakes from "./pages/DropshippingSweepstakes";
import SweepstakesComplianceChecklist from "./pages/SweepstakesComplianceChecklist";
import SweepstakesEntryWidgets from "./pages/SweepstakesEntryWidgets";
import GiveawayBrandsGuide from "./pages/discovery/GiveawayBrandsGuide";
import SweepstakesAgenciesGuide from "./pages/discovery/SweepstakesAgenciesGuide";
import ViralSweepComparison from "./pages/discovery/ViralSweepComparison";
import PineRaffleComparison from "./pages/discovery/PineRaffleComparison";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Convert from "./pages/Convert";
import CustomDevPricing from "./pages/CustomDevPricing";
import WinnerSelect from "./pages/WinnerSelect";
import CountdownScreen from "./pages/CountdownScreen";
import "./App.css";
import "./tool-theme.css";

const ApiDocumentation = lazy(() => import("./docs/ApiDocumentation"));

export function AppShell() {
  const location = useLocation();
  const isCountdownPage = location.pathname === "/winner-select/countdown";

  const isToolPage = /^\/(convert|winner-select)(\/|$)/i.test(location.pathname);

  return (
    <div className={`app-container${isToolPage ? " tool-page" : ""}`}>
      {!isCountdownPage && <Header />}

      <ScrollToTop />

      {/* Add RouteChangeTracker */}
      <RouteChangeTracker />

      {/* Define Routes */}
      <Routes>
        <Route path="/api-documentation/*" element={
          <Suspense fallback={<main className="resources" role="status">Loading documentation…</main>}>
            <ApiDocumentation />
          </Suspense>
        } />
        <Route path="/" element={<Home />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route
          path="/how-to-run-a-sweepstakes"
          element={<HowToRunSweepstakes />}
        />
        <Route path="/resources" element={<Resources />} />
        <Route path="/guides/lgnd-80eighty-sweepstakes" element={<GiveawayBrandsGuide />} />
        <Route path="/guides/sweepstakes-administration-companies" element={<SweepstakesAgenciesGuide />} />
        <Route path="/compare/clean-sweeps-vs-viralsweep" element={<ViralSweepComparison />} />
        <Route path="/compare/clean-sweeps-vs-pineraffle" element={<PineRaffleComparison />} />
        <Route
          path="/dropshipping-sweepstakes"
          element={<DropshippingSweepstakes />}
        />
        <Route
          path="/sweepstakes-compliance-checklist"
          element={<SweepstakesComplianceChecklist />}
        />
        <Route
          path="/sweepstakes-entry-widgets"
          element={<SweepstakesEntryWidgets />}
        />
        <Route path="/setup" element={<Setup />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/tos" element={<TermsOfService />} />
        <Route path="/policy" element={<PrivacyPolicy />} />
        <Route path="/convert" element={<Convert />} />
        <Route path="/winner-select" element={<WinnerSelect />} />
        <Route path="/winner-select/countdown" element={<CountdownScreen />} />
        <Route path="/custom-dev-pricing" element={<CustomDevPricing />} />
      </Routes>

      {!isCountdownPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-B7BG7CPZ2G", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname, location.hash]);

  return null;
}

export default App;
